import React from 'react';
import WaitCube from '../../WaitCube.js'
import $ from "jquery";
import {_GPY,__GPYPost , __GPYGet} from '../../env.js'
import {CopyToClipboard} from 'react-copy-to-clipboard';

class OutputConfig extends React.Component {
  constructor(props) {
   super(props);
   this.state = {
     outputsIsLoaded : false,
     outputs : {},
     currentOutput: {id:-1,format:"1080",theme:"default",displayId:undefined,layoutPk:-1},
     outputUnsave: false,
     currentLayout: {id:-1},
     layoutsIsLoaded : false,
     layouts : {},
   };
  }

  componentDidMount(){
    this.getLayouts();
    this.getOutputs();
  }

  onChange(key,e) {
    var o = this.state.currentOutput;
    o[key] = e.target.value;
    this.setState({currentOutput:o,outputUnsave:true});
  }

  getOutputs() {
    __GPYGet('getOutputs',(res)=>{
      this.setState({
        outputsIsLoaded: true,
        outputs: res,
      });
    },(err)=>{
      this.setState({
        outputsIsLoaded: false,
      });
    });
	}

  createOrUpdateOutput(){
    __GPYPost('createOrUpdateOutput',this.state.currentOutput,(res)=>{
      this.setState({
        outputsIsLoaded: true,
        outputs: res,
        outputUnsave: false,
      });
    });
  }

  getLayouts(){
    __GPYGet('getLayouts',(res)=>{
      console.log(res);
      this.setState({
        layoutsIsLoaded: true,
        layouts: res.Layouts.Layout,
        currentOverlay: {id:-1},
      });
      console.log(this.state.layouts);
      console.log(this.state.layoutsIsLoaded);

    },(err)=>{
      this.setState({
        layoutsIsLoaded: false,
        currentLayout: {id:-1},
      });
    })
  }

  onSelectOutput(o) {
        this.setState({currentOutput:o, copied: false});
  }

  onNewOutput(f){
    this.setState({ currentOutput: {id:-1,format:"1080",theme:"default",displayId:undefined} , copied: false });
     $('#outputFormat').focus();
  }

  deleteOutput(){
    __GPYPost('deleteOutput',this.state.currentOutput,(res)=>{
      this.setState({
        outputsIsLoaded: true,
        outputs: res,
        outputUnsave: false,
      });
      this.onNewOutput();
    });
  }

	render() {
    var isUnsave = function (unsave ,prefix) {
        if(unsave){
          return prefix + "success";
        } else {
          return prefix + "primary disabled";
        }
    }

    return (
      <div>
        <div className="row">
          <div className="col-12 col-lg-3 col-xl-3">

              <div className="row pt-2">
                  <div className="col-8"><h3>Output configuration</h3></div>
                  <div className="col-4 text-right align-bottom"><button type="button" onClick={this.onNewOutput.bind(this)} className="btn btn-light btn-sm"><span className="glyphicon glyphicon-plus"/></button></div>
               </div>

               <div className="row">
                  <div className="col">
                     <div className="list-group">
                        {this.state.outputsIsLoaded ? this.state.outputs.Outputs.Output.map((t) =>
                          <button key={t.id} onClick={this.onSelectOutput.bind(this,t)} className={t.id === this.state.currentOutput.id?"list-group-item list-group-item-action list-group-item-success flex-column align-items-start pointer":"list-group-item list-group-item-action flex-column align-items-start pointer"}>
                             <div className="d-flex w-100 justify-content-start">
                               <span className="glyphicon glyphicon-blackboard" aria-hidden="true"></span>
                               <small className="ml-3"><strong>{t.layout}</strong> layout mit <strong>{Math.floor(t.format*1.7777777778)}x{t.format}</strong></small>
                             </div>
                          </button>
                        ) :  <WaitCube/>  }
                     </div>
                   </div>
               </div>

          </div>
          <div className="col-12 col-lg-9 col-xl-9 pt-2">

                  <div className="card bg-light">
                      <div className="card-header">Output Display</div>
                      <div className="row p-3">

                        <div className="col-12 col-md-6 mb-1">
                            <div className="form-group">
                                <label htmlFor="Layout">Layout</label>
                                 <select className="form-control" value={this.state.currentOutput.layoutPk} onChange={this.onChange.bind(this,"layoutPk")}>
                                     <option key="-1" value="-1">default</option>
                                     {this.state.layoutsIsLoaded ? this.state.layouts.map( (t) =>
                                       <option key={t.id} value={t.id}>{t.name}</option>
                                     ):""}
                                 </select>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 mb-1">
                              <div className="form-group">
                                  <label htmlFor="homeTeam">Format</label>
                                   <select  id="outputFormat" value={this.state.currentOutput.format} onChange={this.onChange.bind(this,"format")} className="form-control">
                                       <option value="">select output format</option>
                                       <option value="720">HD 720(16:9)</option>
                                       <option value="1080">Full HD 1080(16:9)</option>
                                       <option value="2160">4k UHD 2160(16:9)</option>
                                   </select>
                              </div>
                          </div>
{/*
                          <div className="col-12 col-md-4  mb-1">
                              <div className="form-group">
                                  <label htmlFor="homeTeam">Theme</label>
                                   <select className="form-control" value={this.state.currentOutput.theme} onChange={this.onChange.bind(this,"theme")}>
                                       <option value="default">select output theme</option>
                                       <option value="default">Guppyi default</option>
                                   </select>
                              </div>
                          </div>
*/}

                </div>

{this.state.currentOutput.displayId !== undefined && this.state.currentOutput.displayId !== ''?
                    <div className="row p-3">
                          <div className="col-10 col-md-10 mb-1">
                            <strong className="font-monospace">{_GPY.displayUrl}{this.state.currentOutput.displayId}</strong>
                          </div>
                          <div className="col-2 col-md-2 mb-1 text-right">
                              <CopyToClipboard text={_GPY.displayUrl+this.state.currentOutput.displayId} onCopy={() => this.setState({copied: true})}>
                                <button className={this.state.copied?"btn btn-secondary":"btn btn-primary"}>Copy</button>
                              </CopyToClipboard>
                         </div>
                    </div>
:""}

                      <div className="row pl-3 pr-3">
                          <div className="col-12 border-bottom"></div>
                      </div>

                      <div className="row justify-content-end p-3">
                          <div className="col-3 col-md-2 col-lg-2 text-right">
                          <button className={isUnsave(this.state.outputUnsave,"btn btn-")} onClick={this.createOrUpdateOutput.bind(this)}><span className={this.state.currentOutput.id>0?"glyphicon glyphicon-ok":"glyphicon glyphicon-plus"}/></button>
                          <button type="button" className={this.state.currentOutput.id>0?"ml-2 btn btn-danger":"ml-2 btn btn-danger disabled"} onClick={this.deleteOutput.bind(this)}><span className="glyphicon glyphicon-remove"/></button>
                          </div>
                      </div>

                  </div>
            </div>
          </div>

      </div>
		 	);
    }
}
export default OutputConfig;
